import { Breadcrumb } from 'antd';
import React from "react";

export default (() => {
  return (
    <Breadcrumb style={{textAlign: 'left',paddingBottom:20}}>
      <Breadcrumb.Item>推送记录列表</Breadcrumb.Item>
    </Breadcrumb>
  )
})